const i = {
  // Small Device and Up
  smallDeviceAndUp: "@media (min-width: 415px)",
  // Medium Device and Up
  mediumDeviceAndUp: "@media (min-width: 900px)"
};
export {
  i as Breakpoints
};
